export default __webpack_public_path__ + "static/poster-32035c4c2e19a6127937ed9acad32cea.png";